import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL+'api'
export const  imageendpoint = 'https://pruebas-001.ciudadtecnopolis.com/'


export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
export const LOG_OUT = `${API_URL}/logout`
export const CHANGE_PASSWORD_URL = `${API_URL}/change_password`
export const GET_DATA = `${API_URL}/user_profileauth`
export const USER_UPDATE = `${API_URL}/user-update`
export const USER_UPDATE_IMAGE = `${API_URL}/user-updateimage`
export const UPDATE_PDF = `${API_URL}/updatepdf`

export function uploadImages(foto: string) {
  return axios.post(USER_UPDATE_IMAGE, {
    foto
  })
}

export function updatepdf(nombrepdf: string,pdf: string) {
  return axios.post(UPDATE_PDF, {
    nombrepdf,
    pdf
  })
}

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}

export function getData() {
  return axios.post<UserModel>(GET_DATA, {
  })
}

// Server should return AuthModel
export function register(
  firstname: string,
  lastname: string,
  email: string,
  password: string,
  password_confirmation: string,
  acceptTerms: string
) {
  return axios.post(REGISTER_URL, {
    firstname: firstname,
    lastname: lastname,
    email,
    password,
    password_confirmation,
    acceptTerms
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function forgotPassword(email: string) {
  return axios.put<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function changePassword(
    currentPassword: string,
    newPassword: string,
    confirmPassword: string
  ) 
{
  return axios.put(CHANGE_PASSWORD_URL, {
    currentPassword,
    newPassword,
    confirmPassword
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    access_token: token,
  })
}

export function logout(token: string){
  return axios.post<String>(LOG_OUT, {
    access_token: token,
  })
}

export function updateData(
  foto: string,
  firstname: string,
  lastname: string,
  telefono: string,
  cargo: string,
  empresa: string,
  direccion: string,
  pais: string,
  estado: string,
  ciudad: string,
  codpostal: string,
  pagweb: string
) 
{
return axios.put<String>(USER_UPDATE, {
  foto,
  firstname,
  lastname, 
  telefono,
  cargo,
  empresa,
  direccion,
  pais,
  estado,
  ciudad,
  codpostal,
  pagweb
})
}
